<script setup>
import { ref, computed } from 'vue'
// Importamos los componentes desde su carpeta específica
import Navbar from '../../components/Landing/Navbar.vue'
import Hero from '../../components/Landing/Hero.vue'
import HowItWorks from '../../components/Landing/HowItWorks.vue';
import Solutions from '@/components/Landing/Solutions.vue';
import Footer from '@/components/Landing/Footer.vue'
import CursorGlow from '@/components/CursorGlow.vue' // <--- Importas el brillo
</script>

<template>
  <div class="relative bg-[#fcfaf8] min-h-screen font-sans">

    <Navbar/>

    <main>
      <CursorGlow />
      <Hero/>
      <HowItWorks/>
      <Solutions/>
      <Footer/>
    </main>
  </div>
</template>